//import Cookie from 'js-cookie';
// Import redux
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
// Import redux thunk
import reduxThunk from 'redux-thunk';
// Import reducers
import reducers from './reducers';
import { save, load } from 'redux-localstorage-simple';

let store;

// eslint-disable-next-line
if (process.env.NODE_ENV === 'production') {
	const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);

	// Create store
	store = createStoreWithMiddleware(reducers);
} else {
	const createStoreWithMiddleware = applyMiddleware(
		reduxThunk,
		save({ ignoreStates: ['auth'] })
	)(createStore);

	// Create store
	store = createStoreWithMiddleware(reducers, load(), composeWithDevTools());
}

export default store;
